import { themeColors } from "./core";
import { IMenuItem } from "./Interfaces/options";

export const studentMenuItems: IMenuItem[] = [
  { name: "Inicio", link: "/", icon: "" },
  { name: "Materias", link: "/subjects-list", icon: "" },
  {
    name: "Matrícula",
    link: "/subjects-registration/initial",
    icon: "",
    exactLink: "subjects-registration",
  },
  { name: "Caja", link: "/cart/general", icon: "", exactLink: "cart" },
  { name: "Calendario", link: "/calendar", icon: "" },
  { name: "Solicitudes", link: "/requests", icon: "" },
  { name: "Reportes", link: "/reports", icon: "" },
];

export const adminMenuItems: IMenuItem[] = [
  {
    name: "Inicio",
    link: "/",
    icon: "",
    roles: [
      "cajero",
      "administrador(a) del sistema",
      "perfil financiero",
      "vicerrectoria",
      "matricula administrativa",
      "readonly",
    ],
    tooltip: "Inicio",
  },
  {
    name: "Patrocinios",
    link: "/admin/sponsorships",
    icon: "",
    roles: ["perfil financiero", "readonly"],
    tooltip: "Patrocinios",
  },
  // {
  //   name: "Transferencias",
  //   link: "/admin/reviews",
  //   icon: "",
  //   roles: ["perfil financiero"],
  //   tooltip: "Transferencias",
  // },
  {
    name: "Importación",
    link: "/admin/data-imports",
    icon: "",
    roles: ["vicerrectoria"],
    tooltip: "Importaciones de datos",
  },
  {
    name: "Caja",
    link: "/admin/charges",
    icon: "",
    roles: ["cajero"],
    tooltip: "Caja administrativa",
  },
  {
    name: "Ingresar como",
    link: "admin/user-impersonation",
    icon: "",
    roles: ["administrador(a) del sistema"],
    tooltip: "Ingresar como usuario estudiante",
  },
  {
    name: "Ingreso prof.",
    link: "admin/teacher-impersonation",
    icon: "",
    roles: ["director de escuela"],
    tooltip: "Ingresar como usuario docente",
  },
  {
    name: "Pre-matrícula",
    link: "admin/user-selection",
    icon: "",
    roles: ["matricula administrativa"],
    tooltip: "Pre-matrícula",
  },
  {
    name: "Retiro admin",
    link: "/admin/subjects-withdraw",
    icon: "",
    roles: ["retiro administrativo"],
    tooltip: "Retiro administrativo",
  },
  {
    name: "Configuración",
    link: "/admin/settings",
    icon: "",
    roles: ["administrador(a) del sistema"],
    tooltip: "Configuraciones",
  },
];
export const teacherMenuItems: IMenuItem[] = [
  {
    name: "Inicio",
    link: "/",
    icon: "",
  },
  { name: "Cursos", link: "teacher/courses", icon: "" },
  { name: "Solicitudes", link: "/requests", icon: "" },
];

const breakpoints = {
  xs: "320px",
  sm: "480px",
  md: "600px",
  lg: "801px",
  xl: "1025px",
  "2xl": "1281px",
};

export const devices = {
  xs: `(max-width: ${breakpoints.sm})`,
  sm: `(min-width: ${breakpoints.sm}) and (max-width: ${breakpoints.xl})`,
  md: `(max-width: ${breakpoints.lg})`,
  lg: `(max-width: ${breakpoints.xl})`,
  xl: `(min-width: ${breakpoints.xl})`,
  "2xl": `(min-width: ${breakpoints["2xl"]})`,
};

export const horas = [
  {
    twentyFour: "08:00",
    twelve: "08:00 AM",
  },
  {
    twentyFour: "09:00",
    twelve: "09:00 AM",
  },
  {
    twentyFour: "10:00",
    twelve: "10:00 AM",
  },
  {
    twentyFour: "11:00",
    twelve: "11:00 AM",
  },
  {
    twentyFour: "12:00",
    twelve: "12:00 PM",
  },
  {
    twentyFour: "13:00",
    twelve: "01:00 PM",
  },
  {
    twentyFour: "14:00",
    twelve: "02:00 PM",
  },
  {
    twentyFour: "15:00",
    twelve: "03:00 PM",
  },
  {
    twentyFour: "16:00",
    twelve: "04:00 PM",
  },
  {
    twentyFour: "17:00",
    twelve: "05:00 PM",
  },
  {
    twentyFour: "18:00",
    twelve: "06:00 PM",
  },
  {
    twentyFour: "19:00",
    twelve: "07:00 PM",
  },
  {
    twentyFour: "20:00",
    twelve: "08:00 PM",
  },
  {
    twentyFour: "21:00",
    twelve: "09:00 PM",
  },
  {
    twentyFour: "22:00",
    twelve: "10:00 PM",
  },
];

export const weekDays = [
  { diaId: 7, acr: "Do", name: "Domingo" },
  { diaId: 1, acr: "Lun", name: "Lunes" },
  { diaId: 2, acr: "Mar", name: "Martes" },
  { diaId: 3, acr: "Mie", name: "Miercoles" }, //falta acento en miercoles en backend
  { diaId: 4, acr: "Jue", name: "Jueves" },
  { diaId: 5, acr: "Vie", name: "Viernes" },
  { diaId: 6, acr: "Sa", name: "Sábado" },
];

export const toastSuccessStyle = {
  style: {
    padding: "16px",
    color: `${themeColors.primary500}`,
    fontSize: 15,
    fontWeight: 700,
  },
  iconTheme: {
    primary: `${themeColors.primary500}`,
    secondary: "#FFF",
  },
};

export const toastErrorStyle = {
  style: {
    padding: "16px",
    color: "#e74c3c",
    width: "500px",
    fontSize: 15,
    fontWeight: 700,
  },
  iconTheme: {
    primary: "#e74c3c",
    secondary: "#FFF",
  },
};
export const toastWarningStyle = {
  style: {
    padding: "16px",
    color: "#e0ae00",
    fontSize: 17,
    fontWeight: 700,
  },
  iconTheme: {
    primary: "#e0ae00",
    secondary: "#FFF",
  },
};

export const NUMBER = "Numero";
export const SHORT_TEXT = "Texto Corto";
export const LONG_TEXT = "Texto Largo";
export const BOOLEAN = "Booleano";
export const EMAIL = "Email";
export const OPTIONS = "Opciones";
export const MULTI_OPTIONS = "MultiOpciones";
export const EDITOR = "Editor";
export const CODE_EDITOR = "CodeEditor";
export const FECHA = "Fecha";
export const RADIO = "Radio";
export const CLAVE = "Clave";

export const COLORS = {
  calendar: {
    "1": {
      background: "#ac725e",
      foreground: "#1d1d1d",
    },
    "2": {
      background: "#d06b64",
      foreground: "#1d1d1d",
    },
    "3": {
      background: "#f83a22",
      foreground: "#1d1d1d",
    },
    "4": {
      background: "#fa573c",
      foreground: "#1d1d1d",
    },
    "5": {
      background: "#ff7537",
      foreground: "#1d1d1d",
    },
    "6": {
      background: "#ffad46",
      foreground: "#1d1d1d",
    },
    "7": {
      background: "#42d692",
      foreground: "#1d1d1d",
    },
    "8": {
      background: "#16a765",
      foreground: "#1d1d1d",
    },
    "9": {
      background: "#7bd148",
      foreground: "#1d1d1d",
    },
    "10": {
      background: "#b3dc6c",
      foreground: "#1d1d1d",
    },
    "11": {
      background: "#fbe983",
      foreground: "#1d1d1d",
    },
    "12": {
      background: "#fad165",
      foreground: "#1d1d1d",
    },
    "13": {
      background: "#92e1c0",
      foreground: "#1d1d1d",
    },
    "14": {
      background: "#9fe1e7",
      foreground: "#1d1d1d",
    },
    "15": {
      background: "#9fc6e7",
      foreground: "#1d1d1d",
    },
    "16": {
      background: "#4986e7",
      foreground: "#1d1d1d",
    },
    "17": {
      background: "#9a9cff",
      foreground: "#1d1d1d",
    },
    "18": {
      background: "#b99aff",
      foreground: "#1d1d1d",
    },
    "19": {
      background: "#c2c2c2",
      foreground: "#1d1d1d",
    },
    "20": {
      background: "#cabdbf",
      foreground: "#1d1d1d",
    },
    "21": {
      background: "#cca6ac",
      foreground: "#1d1d1d",
    },
    "22": {
      background: "#f691b2",
      foreground: "#1d1d1d",
    },
    "23": {
      background: "#cd74e6",
      foreground: "#1d1d1d",
    },
    "24": {
      background: "#a47ae2",
      foreground: "#1d1d1d",
    },
  },
  event: {
    "1": {
      background: "#a4bdfc",
      foreground: "#1d1d1d",
    },
    "2": {
      background: "#7ae7bf",
      foreground: "#1d1d1d",
    },
    "3": {
      background: "#dbadff",
      foreground: "#1d1d1d",
    },
    "4": {
      background: "#ff887c",
      foreground: "#1d1d1d",
    },
    "5": {
      background: "#fbd75b",
      foreground: "#1d1d1d",
    },
    "6": {
      background: "#ffb878",
      foreground: "#1d1d1d",
    },
    "7": {
      background: "#46d6db",
      foreground: "#1d1d1d",
    },
    "8": {
      background: "#e1e1e1",
      foreground: "#1d1d1d",
    },
    "9": {
      background: "#5484ed",
      foreground: "#1d1d1d",
    },
    "10": {
      background: "#51b749",
      foreground: "#1d1d1d",
    },
    "11": {
      background: "#dc2127",
      foreground: "#1d1d1d",
    },
  },
};

export const fallbackImage =
  "data:image/png;base64,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";
